
import { throws } from "assert";
import { FocusManager } from "components/pages/focusManager";
import { MenuEntry } from "./menuEntry";
import template from "./menuLeafNodeElement.hbs";
import Mousetrap from "mousetrap";

export class MenuLeafNodeElement extends HTMLElement {
    private _entry: MenuEntryWithEnvironment;
    private _active = false;

    constructor() {
        super();
    }

    public connectedCallback() {
        this.innerHTML = template(this._entry);
        this.querySelector("a")?.classList.toggle("c-menu-leaf-node--active", this._active);
    }
    public set entry(entry: MenuEntryWithEnvironment) {
        this._entry = entry;
    }

    private get pageId() {
        return this._entry.page ?? this._entry.legacyUrl ?? this._entry.url.split("/").slice(-1)[0];
    }

    set active(a: string) {
        this._active = (a === this.pageId);
        this.querySelector("a")?.classList.toggle("c-menu-leaf-node--active", this._active);
    }
}

export function initMenuLeafNodeWebComponent() {
    window.customElements.define("s6-menu-node-leaf", MenuLeafNodeElement);
}

export interface MenuEntryWithEnvironment extends MenuEntry {
    environment: object;
    level: number,
    appPrefix: string
}